<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <el-form :model="formInline"
                   class="demo-form-inline">
            <el-col :span="7">
              <el-form-item label="账号：">
                <el-input v-model="formInline.username"
                          placeholder="请输入账号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="部门：">
                <el-select v-model="formInline.deptName"
                         placeholder="请选择">
                <el-option v-for="item in deptlist"
                           :key="item.value"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
                <el-button type="primary"
                           style="margin-left:20px"
                           @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                   style="margin-right:10px"></i>用户列表</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <el-button type="primary"
                         style="margin-left:20px"
                         @click="add"
                         size="mini">添加用户</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <div style="overflow:auto">
                <el-table border
                          ref="multipleTable"
                          :data="tableData"
                          tooltip-effect="dark"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection">
                  </el-table-column>
                  <el-table-column prop="username"
                                   label="账号">
                  </el-table-column>
                  <el-table-column prop="phone"
                                   label="联系方式">
                  </el-table-column>
                  <el-table-column prop="deptName"
                                   label="部门">
                  </el-table-column>
                  <el-table-column label="是否代理"
                                   width="100">
                    <template slot-scope="scope">
                      <span v-show="scope.row.agent==0">否</span>
                      <span v-show="scope.row.agent==1">是</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="agentPhoneNumber"
                                   label="是否启用">
                    <template slot-scope="scope">
                      <el-switch disabled
                                 active-value='0'
                                 @click.native="handleClick(scope.$index,scope.row)"
                                 v-model="scope.row.lockFlag"
                                 inactive-value='9'>
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address"
                                   label="操作"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button @click="check1(scope.row.userId)"
                                 type="text"
                                 size="small">编辑</el-button>
                      <el-button type="text"
                                 size="small"
                                 @click="deleteTable(scope.$index, tableData,scope.row.userId)">删除</el-button>

                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div style="margin-top: 20px;padding:20px">
                <el-checkbox v-model="checked"
                             @change="toggleAllSelection">全选</el-checkbox>
                <el-button @click="deleteTables"
                size="mini"
                style="margin-left:20px"
                           type="danger">批量删除</el-button>
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getuser, deleteuser, deletesuser, lockrole,getmenu,postdeptlist,getmenuTree } from '../../API'
export default {
  data () {
    return {
      formInline: {},
      checked: false,
      total: 0,
      current: 1,
      tableData: [],
      value: 0,
      multipleSelection: [],
      deptlist:[]
    }
  },
  created () {
    getuser().then(res => {
      if (res.code === 0) {
        this.total = res.data.total;
        this.current = res.data.current;
        this.tableData = res.data.records
      }
    })
    getmenu()
    let params={
      lazy:false,
      parentId:-1
    }
    getmenuTree(params)
    postdeptlist().then(res => {
      if (res.code === 0) {
        this.deptlist = res.data
      }
    })
  },
  methods: {
    handleClick (index, row) {
      if (row.lockFlag == 0) {
        this.$confirm('是否关闭启用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = row.userId + '?lockFlag=9'
          lockrole(params).then((res) => {
            if (res.code == 0) {
              this.$message.success('成功关闭启用！');
              this.$set(this.tableData[index], 'lockFlag', '9')
            }
            else {
              if (res.errorCode == '5000') {
                setTimeout(function () {
                  _this.$router.push({ path: '/login' });
                }, 500)
              }
              else {
                this.$message.error(res.msg);
              }
            }
          }).catch(error => {
            this.$message.error('网络加载失败！');
          }).finally()
        }).catch(() => {
        });
      }
      else {
        let params = row.userId + '?lockFlag=0'
        lockrole(params).then((res) => {
          if (res.code === 0) {
            this.$set(this.tableData[index], 'lockFlag', '0')
            this.$message.success('成功开启启用！');
          }
          else {
            if (res.errorCode == '5000') {
              setTimeout(function () {
                _this.$router.push({ path: '/login' });
              }, 500)
            }
            else {
              this.$message.error(res.msg);
            }
          }
        }).catch(error => {
          this.$message.error('网络加载失败！');
        }).finally()
      }
    },
    getParentName (value) {
      let obj = this.deptlist.find((item) => {//这里的oneData就是上面遍历的数据源
        return item.deptId === value;//筛选出匹配数据
      });
      this.deptname = obj.name
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteuser(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getClientPage().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].userId)
        }
        deletesuser(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getuser().then(res => {
              if (res.code === 0) {
                this.total = res.data.total;
                this.current = res.data.current;
                this.tableData = res.data.records
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit () {
      let params = this.formInline
      params.current = this.current
      console.log(params)
      getuser(params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
    check1 (id) {
      this.$router.push({ path: '/qxgl/xgyh', query: { text: '修改客户资料', } })
      localStorage.setItem("userIdbj", id)
    },
    handleCurrentChange (val) {
      this.current = val
      this.onSubmit()
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    check (row) {
      this.$router.push({ path: '/CustomerManagement/CustomerInformation', query: { id: row.id } })
      localStorage.setItem('id', row.id)
    }, add () {
      this.$router.push('/qxgl/tjyh')
      localStorage.removeItem('userIdbj')
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
/deep/.el-input {
  width: 217px;
}
/deep/ .el-table {
  max-width: 200%;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
  /deep/ .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label {
    cursor: pointer
  }
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
  /deep/ .el-input {
    width: 50px;
  }
}
</style>
